class NewsletterForm extends HTMLElement {
  #form = null;
  #emailInput = null;
  #errorEl = null;

  connectedCallback() {
    this.#form = this.querySelector('form');
    this.#emailInput = this.querySelector('input[type="email"]');
    this.#errorEl = this.querySelector('[data-newsletter-errors]');

    if (!this.#form || !this.#emailInput || !this.#errorEl) return;

    this.#form.addEventListener('submit', (event) => this.#onSubmit(event));
    this.#emailInput.addEventListener('input', () => this.#onInput());
  }

  /**
   * @param {SubmitEvent} event
   */
  #onSubmit(event) {
    if (this.#emailInput.checkValidity()) {
      this.#clearError();
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    this.#showError();
    this.#emailInput.focus();
  }

  #onInput() {
    if (this.#emailInput.checkValidity()) {
      this.#clearError();
    }
  }

  #showError() {
    const message = this.#emailInput.validity.valueMissing
      ? this.dataset.errorRequired
      : this.dataset.errorInvalid;

    this.#errorEl.textContent = message;
    this.#errorEl.classList.remove('hidden');
    this.#emailInput.setAttribute('aria-invalid', 'true');
  }

  #clearError() {
    this.#errorEl.textContent = '';
    this.#errorEl.classList.add('hidden');
    this.#emailInput.removeAttribute('aria-invalid');
  }
}

customElements.define('newsletter-form', NewsletterForm);
